module.exports = __webpack_public_path__ + "69bc478f1e3ffe11afdc4db9b2598cbc.pdf";